import { gql } from '@apollo/client'

export const SaveProprietaryCategoriesByFamily = gql`
    mutation setProprietaryCategoriesByFamily(
        $input: SetProprietaryCategoriesByFamilyInput!
    ) {
        setProprietaryCategoriesByFamily(input: $input) {
            id
            dataType
            sectionNumber
            sectionTitle
            meta {
                addedBy
                addedDate
                lastUpdatedBy
                lastUpdatedDate
                lastVerifiedBy
                lastVerifiedDate
                reviewedBy
                reviewedDate
            }
        }
    }
`
